import React, { useState } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { CheckIcon } from '../../../../../components/Icon';
import { onKeyUpEnterOrSpace } from '../../../../../utils';

const useStyles = makeStyles((theme) => ({
  root: ({ backgroundColor, border }) => ({
    width: '1.5rem',
    height: '1.5rem',
    borderRadius: '4px',
    background: backgroundColor,
    border: border,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }),
  checkIcon: {
    width: '1rem',
    height: '1rem',
    color: '#fff',
  },
  rect: {
    width: '0.813rem',
    height: '0.063rem',
    border: 'solid 2px #fff',
  },
}));

export default function CkeckBox({ disabled, flaw, checked, onChange }) {
  const [ISChecked, setISChecked] = useState(Boolean(checked));
  const onChangeHandle = () => {
    setISChecked(!ISChecked);
    if (typeof onChange === 'function') {
      onChange(!ISChecked);
    }
  };
  const onClickCtr = () => {
    if (disabled || flaw) {
      return null;
    } else {
      return onChangeHandle;
    }
  };

  const styleProps = () => {
    if (disabled || flaw) {
      return { backgroundColor: '#c0c6cb', border: '0px' };
    } else if (ISChecked) {
      return { backgroundColor: '#28d2ab', border: '0px' };
    } else {
      return { backgroundColor: '#fff', border: '2px solid #c0c6cb' };
    }
  };
  const classes = useStyles(styleProps());

  return (
    <Box display="inline-block">
      <div
        className={classes.root}
        onClick={onClickCtr()}
        tabIndex={0}
        onKeyUp={(e) => onKeyUpEnterOrSpace(e, onClickCtr())}
      >
        {flaw ? (
          <div className={classes.rect} />
        ) : (
          <CheckIcon className={classes.checkIcon} style={disabled && !ISChecked ? { color: '#c0c6cb' } : null} />
        )}
      </div>
    </Box>
  );
}
